  import React, { useState, useEffect } from "react";
  import { useUser } from "../../../context/UserContext";
  import {
    getDocumentFirebaseId,
    getDocumentsFirebase,
  /*   updateDocumentFirebase, */
  } from "../../../services/data-firebase.js";

  import { motion, AnimatePresence } from "framer-motion";
  import { 
    FaUserFriends, 
    FaHome, 
    FaEnvelope, 
    FaClock,
    FaSun,
    FaMoon,
    FaCloudSun
  } from "react-icons/fa";


  import CalendarProfesional from "./CalendarProfesional.jsx";
  import ModalInfoUser from "./ModalInfoUser.jsx";
  import SubscriptionComponent from "../../Subscription/SubscriptionComponent.jsx";
  import SvgRefresh from "../../../assets/imagen/svg/SvgRefresh.jsx";

  import logoNiñeraYa from "../../../assets/imagen/logo-niñeras-ya.JPG"
  import ModalMembre from "./modalMembre/ModaMembre.jsx";
  import ServiciosMembresia from "./ServiciosMembresia.jsx";

  const ProfessionalUI = () => {
    const { user, setUser } = useUser();

    const [statusColor, setStatusColor] = useState("bg-gray-400");
    const [filteredData, setFilteredData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    const [dataFromSubs, setDataFromSubs] = useState(null)
    const [datesForCalendarMembre, setDatesForCalendarMembre] = useState([])
    // Función para obtener los datos del usuario y los datos filtrados
    const fetchData = async () => {
      try {
        // Obtener los datos relacionados al usuario desde Firebase
        const updatedUser = await getDocumentFirebaseId("nana", user.idFirestore);

        // Actualizar el estado del usuario en el contexto
        setUser(updatedUser);

        // Act  ualizar el color basado en el estado del usuario
        setStatusColor(updatedUser.state ? "bg-green-500" : "bg-gray-400");

       // console.log(updatedUser, "Usuario actualizado desde Firebase");

        // Obtener datos relacionados al usuario (filteredData) obtego todo los datos de la collecion match que tengan el mismo idFiresotre de la niñera 
        const dataService = await getDocumentsFirebase("match");
        const filterDataWithIdFirestore = dataService.filter(
          (item) => item.idNana === user.idFirestore
        );

        // get data from service user membre, filter data with user.id --> id of nana 

        const dataServiceSubs = await getDocumentsFirebase('match-subs')

        const dataFilterFromSeviceUser = dataServiceSubs.filter((service)=> service.idNana === user.idFirestore)

        setFilteredData(filterDataWithIdFirestore); // get all services match 
        setDataFromSubs(dataFilterFromSeviceUser)//  get all services from membre
      } catch (error) {
        console.error("Error al actualizar los datos:", error);
      }
    };

    useEffect(() => {
      fetchData(); // Llamar a fetchData cuando se monta el componente
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Función para alternar el estado del usuario

// Crear un array con todos los días de diasServicio aceptados
useEffect(() => {
  if (dataFromSubs) {
  //console.log(dataFromSubs, 'desde el useEffect');

    // Filtrar solo los servicios con estado aceptado
    const acceptedServices = dataFromSubs.filter((item) => item.state);

    // Extraer los días de los servicios aceptados
    const allDays = acceptedServices.flatMap((item) => item.diasServicio || []);
  //console.log(allDays,'dias solo true ')
    // Actualizar el estado con los días aceptados
    setDatesForCalendarMembre(allDays);
  }
}, [dataFromSubs]);
    
    const handleOpenModal = (data) => {
      setSelectedData(data);
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
      setIsModalOpen(false);
      setSelectedData(null);
    };
/*     
    if (dataFromSubs) {
      console.log(dataFromSubs,'dataFromSubs');
      
    } */

    return (
      <section className="bg-gray-100 min-h-screen py-2 px-2">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-6">
          <div className="flex items-center space-x-6">
            <div className="relative">
              <img
                src={user.urlAvatar?user.urlAvatar: logoNiñeraYa}  // url de la niñeras o url del logo de niñera ya
                alt="Avatar Profesional"
                className="w-24 h-24 rounded-full border-4 border-pink-500 shadow-md"
              />
              <span
                className={`absolute bottom-0 right-0 w-6 h-6 ${statusColor} border-2 border-white rounded-full shadow`}
              ></span>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-800">
                {user?.name || "Nombre Profesional"}
              </h2>
              <p className="text-gray-600">Dirección</p>
              <p className="text-gray-600">{user?.address || "Sin dirección"}</p>
            </div>
          </div>

          <div className="mt-6 flex flex-row w-full justify-around ">
              <button
                onClick={fetchData} // Llamar a fetchData al hacer clic
              // Refrescar Datos
                className="bg-[#e896ef] text-white px-4  rounded-md ml-4 hover:bg-[#eec7e9]"
              >
              <SvgRefresh fetchData={fetchData}/>
              </button>
                  {/* Cambia 'parent' a 'nanny' según el tipo de usuario */}
            {user.subs ? <ModalMembre serviceSub = {dataFromSubs}  fetchData={fetchData} /> :
              <SubscriptionComponent userType="nanny" />
            }
            </div>

          {/* Servicios de membresía aceptados */}
          {dataFromSubs && dataFromSubs?.filter((item) => item.state).length > 0 ? (
            <div className="z-80">
              <ServiciosMembresia dataFromSubs={dataFromSubs.filter((item) => item.state)} />
            </div>
          ) : null}


 {/* Listado de servicios */}
<div className="mt-8 mb-4">
  <h3 className="text-xl font-bold text-gray-700 mb-4">Servicios</h3>
  
  <AnimatePresence>
    {filteredData.length > 0 ? (
      <ul className="space-y-4">
        {filteredData.map((item, index) => {
          const schedule = item.mother?.services?.[0]?.schedule || "mañana";
          
          const scheduleColors = {
            mañana: "bg-yellow-100 border-l-4 border-yellow-500",
            tarde: "bg-blue-100 border-l-4 border-blue-500",
            noche: "bg-purple-100 border-l-4 border-purple-500",
          };

          const scheduleIcons = {
            mañana: <FaSun className="text-yellow-500" />,
            tarde: <FaCloudSun className="text-blue-500" />,
            noche: <FaMoon className="text-purple-500" />,
          };

          const cardColor = scheduleColors[schedule];
          const scheduleIcon = scheduleIcons[schedule];

          return (
            <motion.li
              key={item.id || index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
              className={`p-4 rounded-lg shadow-sm cursor-pointer hover:shadow-md transition-shadow ${cardColor}`}
              onClick={() => handleOpenModal(item)}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="flex1 items-start space-x-3">
                <div className="">
                  {scheduleIcon}
                </div>
                <div className="flex-1">
                  <div className="flex items-center space-x-2">
                    <FaUserFriends className="text-gray-600" />
                    <p className="text-lg font-semibold text-gray-800">
                      {item.mother?.name || "Nombre no disponible"}
                    </p>
                  </div>
                  
                  <div className="mt-2 space-y-2 pl-7">
                    <div className="flex items-center space-x-2">
                      <FaHome className="text-gray-600" />
                      <p className="text-gray-700">
                        {item.mother?.address || "Dirección no disponible"}
                      </p>
                    </div>
                    
                    <div className="flex items-center space-x-2">
                      <FaEnvelope className="text-gray-600" />
                      <p className="text-gray-700">
                        {item.mother?.email || "Email no disponible"}
                      </p>
                    </div>
                    
                    <div className="flex items-center space-x-2">
                      <FaClock className="text-gray-600" />
                      <p className="text-gray-700 capitalize">
                        {schedule}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.li>
          );
        })}
      </ul>
    ) : (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center justify-center py-8"
      >
        <div className="bg-gray-100 p-4 rounded-full mb-3">
          <FaUserFriends className="text-gray-400 text-2xl" />
        </div>
        <p className="text-gray-500">No se encontraron servicios</p>
      </motion.div>
    )}
  </AnimatePresence>
</div>


          {/* Componente del calendario */}
          <CalendarProfesional
            filteredData={filteredData}
            fechaMembre={datesForCalendarMembre} // Pasar el array de días al calendario
          />

          {/* Modal para informacion del servicio con datos del usario y detalle del servicio que se solicito */}

          {isModalOpen && selectedData && (
          <ModalInfoUser selectedData={selectedData} handleCloseModal={handleCloseModal} />
          )}

        </div>
      </section>
    );
  };

  export default ProfessionalUI;



 